import { appConfig } from 'config/customization';
import { customerSupportTopbarSize, accountSelectorSize } from 'constants/sizes';
import Device from 'constants/deviceSizes';

export default {
  activeRowStyle: {
    backgroundColor: appConfig.colors.activeRowColor,
    boxShadow: 'inset -2px 73px 46px -87px rgba(0,0,0,1)'
  },
  container: {
    height: '100%'
  },
  table: {
    height: `calc(100% - ${customerSupportTopbarSize}px)`,
    [Device.mobile]: {
      height: 'auto'
    }
  },
  selectContainer: {
    border: `1px solid ${appConfig.colors.bordersGray}`,
    borderRadius: 5,
    justifyContent: 'space-between',
    minWidth: accountSelectorSize,
    display: 'flex',
    flex: 0.6,
    [Device.mobile]: {
      width: '100%',
      flex: '0.5 1 auto',
      marginTop: 10
    }
  },
  selectPopUp: {
    width: '100%',
    justifyContent: 'space-between'
  },
  formCreator: {
    visibility: 'hidden'
  },
  spinnerContainer: {
    position: 'fixed',
    bottom: 0,
    padding: 5,
    backgroundColor: appConfig.colors.lightGray,
    width: 'calc(100% - 260px)',
    [Device.tablet_mobile]: {
      width: '100%'
    }
  }
};
